module.exports = __webpack_public_path__ + "static/media/直播行业解决方案.178ed018.png";